import { render, staticRenderFns } from "./SelfFooter.vue?vue&type=template&id=07da59e2&scoped=true&"
var script = {}
import style0 from "./SelfFooter.vue?vue&type=style&index=0&id=07da59e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da59e2",
  null
  
)

export default component.exports